/**
 * @generated SignedSource<<59c466df5cb6fc6e4722153a0a689048>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomContentInput = {
  attribs?: CustomContentInputAttributes | null | undefined;
  row?: number | null | undefined;
  type: string;
};
export type CustomContentInputAttributes = {
  infiniteAdsAfterNumber?: string | null | undefined;
  percentage?: string | null | undefined;
  tag?: string | null | undefined;
};
export type sectionPageQuery$variables = {
  applicationId: string;
  articlesQueueName: string;
  commentHarrySectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  commentQueueLimit: number;
  commentQueueName: string;
  customContents?: ReadonlyArray<CustomContentInput | null | undefined> | null | undefined;
  dailyPulseTypeUuId: string;
  editorPicksQueueName: string;
  entityId: string;
  focusQueueName: string;
  highlightQueueName: string;
  includeAsiaDiscoveryWidget: boolean;
  includeChinaFutureTechDiscoveryWidget: boolean;
  includeChinaScienceDiscoveryWidget: boolean;
  includeComment: boolean;
  includeEditorPicks: boolean;
  includeFocusArticle: boolean;
  includeMostPopular: boolean;
  includeMultimedia: boolean;
  includeOpenQuestionsSeriesDiscoveryWidget: boolean;
  includePlus: boolean;
  includeThisWeekInAsiaDiscovery: boolean;
  includeTrendingTopics: boolean;
  isPostMagazineSection: boolean;
  isSkipDefaultSectionQuery: boolean;
  isStyleSection: boolean;
  mostPopularQueueName: string;
  multimediaQueueName: string;
  plusNewsAgendaEndDate: number;
  plusNewsAgendaStartDate: number;
  plusNewsAgendaTypes: ReadonlyArray<string | null | undefined>;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  sectionSpotlightQueueName: string;
  sponsorQueueName: string;
  trendingTopicsQueueName: string;
};
export type sectionPageQuery$data = {
  readonly section: {
    readonly entityId: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"contextsSectionContextProviderSection" | "hooksTrackCurrentItemBase" | "sectionSeoSection">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"defaultSectionQuery" | "sectionPostMagazineQuery" | "sectionStyleContentQuery">;
};
export type sectionPageQuery = {
  response: sectionPageQuery$data;
  variables: sectionPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "articlesQueueName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentHarrySectionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueLimit"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueName"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customContents"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dailyPulseTypeUuId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "editorPicksQueueName"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "focusQueueName"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "highlightQueueName"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAsiaDiscoveryWidget"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeChinaFutureTechDiscoveryWidget"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeChinaScienceDiscoveryWidget"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeComment"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeEditorPicks"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFocusArticle"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMostPopular"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMultimedia"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOpenQuestionsSeriesDiscoveryWidget"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includePlus"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeThisWeekInAsiaDiscovery"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTrendingTopics"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPostMagazineSection"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSkipDefaultSectionQuery"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStyleSection"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostPopularQueueName"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "multimediaQueueName"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaEndDate"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaStartDate"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaTypes"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scmpPlusPaywallTypeIds"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sectionSpotlightQueueName"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sponsorQueueName"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trendingTopicsQueueName"
},
v35 = {
  "kind": "Variable",
  "name": "entityId",
  "variableName": "entityId"
},
v36 = [
  {
    "fields": [
      (v35/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v42 = {
  "kind": "Variable",
  "name": "customContents",
  "variableName": "customContents"
},
v43 = [
  {
    "kind": "Variable",
    "name": "bodyType",
    "variableName": "bodyType"
  },
  (v42/*: any*/)
],
v44 = [
  (v37/*: any*/)
],
v45 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "contentShareWidgetContent"
},
v46 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v46/*: any*/),
        (v47/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = [
  (v48/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v51 = [
  (v38/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentiment",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v55 = [
  (v37/*: any*/),
  (v38/*: any*/)
],
v56 = {
  "kind": "InlineFragment",
  "selections": (v55/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v56/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": (v51/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v58/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v46/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v61 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v63 = [
  {
    "defaultValue": "PARAGRAPH",
    "kind": "LocalArgument",
    "name": "bodyType"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "customContents"
  }
],
v64 = [
  (v45/*: any*/)
],
v65 = {
  "kind": "Variable",
  "name": "applicationId",
  "variableName": "applicationId"
},
v66 = {
  "kind": "Variable",
  "name": "articlesQueueName",
  "variableName": "articlesQueueName"
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v68 = [
  (v67/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v71 = [
  (v70/*: any*/)
],
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    (v73/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v76 = [
  (v38/*: any*/),
  (v73/*: any*/)
],
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v73/*: any*/)
  ],
  "storageKey": null
},
v79 = [
  (v37/*: any*/),
  (v73/*: any*/)
],
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v79/*: any*/),
  "storageKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v79/*: any*/),
      "storageKey": null
    },
    (v72/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v73/*: any*/)
  ],
  "storageKey": null
},
v84 = {
  "kind": "InlineFragment",
  "selections": [
    (v82/*: any*/),
    (v83/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v54/*: any*/),
    (v73/*: any*/)
  ],
  "storageKey": null
},
v86 = {
  "kind": "InlineFragment",
  "selections": [
    (v85/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v87 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v39/*: any*/),
            (v46/*: any*/),
            (v75/*: any*/),
            (v47/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v86/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v88 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    (v50/*: any*/),
    (v78/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v84/*: any*/),
    (v87/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v54/*: any*/),
    (v50/*: any*/),
    (v78/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v84/*: any*/),
    (v87/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v92 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "768x768"
    }
  }
],
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v98 = {
  "kind": "InlineFragment",
  "selections": (v51/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v91/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v71/*: any*/),
      "storageKey": null
    },
    (v73/*: any*/)
  ],
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v100/*: any*/)
  ],
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeId",
  "storageKey": null
},
v103 = {
  "kind": "InlineFragment",
  "selections": [
    (v102/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    (v38/*: any*/),
    (v50/*: any*/)
  ],
  "type": "Topic",
  "abstractKey": null
},
v105 = [
  (v38/*: any*/),
  (v50/*: any*/),
  (v78/*: any*/)
],
v106 = {
  "kind": "InlineFragment",
  "selections": (v105/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/),
    (v54/*: any*/),
    (v50/*: any*/),
    (v78/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v84/*: any*/),
    (v87/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settings",
  "storageKey": null
},
v109 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "TERM_LOGO"
    }
  }
],
v110 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "style": "100x100"
        }
      }
    ],
    "concreteType": "ImageStyle",
    "kind": "LinkedField",
    "name": "style",
    "plural": false,
    "selections": (v71/*: any*/),
    "storageKey": "style(filter:{\"style\":\"100x100\"})"
  }
],
v111 = {
  "alias": "sectionLogo",
  "args": (v109/*: any*/),
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v110/*: any*/),
  "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v113 = [
  (v112/*: any*/)
],
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v115 = [
  (v114/*: any*/)
],
v116 = {
  "kind": "InlineFragment",
  "selections": (v115/*: any*/),
  "type": "Author",
  "abstractKey": null
},
v117 = {
  "kind": "InlineFragment",
  "selections": (v115/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v118 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "articlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v119 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v69/*: any*/),
    (v94/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v68/*: any*/),
      "storageKey": null
    },
    (v73/*: any*/)
  ],
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v123 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "1200x800"
    }
  }
],
v124 = {
  "alias": "size1200x800",
  "args": (v123/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v71/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v125 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v71/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v126 = {
  "alias": "landscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v71/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v127 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isSectionUnion"
},
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v39/*: any*/),
        (v127/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v38/*: any*/),
            (v119/*: any*/)
          ],
          "type": "Section",
          "abstractKey": null
        },
        (v98/*: any*/),
        (v75/*: any*/),
        (v107/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v113/*: any*/),
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v112/*: any*/),
    (v67/*: any*/)
  ],
  "storageKey": null
},
v131 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v86/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v132 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    (v78/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v84/*: any*/),
    (v131/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v134 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v37/*: any*/),
    (v54/*: any*/),
    (v50/*: any*/),
    (v78/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v84/*: any*/),
    (v87/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "seriesContainer",
  "plural": false,
  "selections": [
    (v133/*: any*/),
    (v73/*: any*/),
    (v134/*: any*/)
  ],
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v113/*: any*/),
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v37/*: any*/),
        (v73/*: any*/),
        (v38/*: any*/),
        (v69/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v100/*: any*/),
    (v73/*: any*/),
    (v37/*: any*/)
  ],
  "storageKey": null
},
v140 = [
  (v70/*: any*/),
  (v122/*: any*/),
  (v91/*: any*/),
  (v124/*: any*/),
  (v125/*: any*/)
],
v141 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "leadingSlides",
  "plural": true,
  "selections": (v140/*: any*/),
  "storageKey": null
},
v142 = {
  "kind": "InlineFragment",
  "selections": (v49/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v144 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v47/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v145 = {
  "kind": "InlineFragment",
  "selections": [
    (v102/*: any*/),
    (v143/*: any*/),
    (v144/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v146 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "sectionSpotlightQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v147 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v148 = [
  (v147/*: any*/)
],
v149 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v150 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v39/*: any*/),
          (v149/*: any*/),
          (v75/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v151 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "commentQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v152 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "commentQueueLimit"
  }
],
v153 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v54/*: any*/),
    (v78/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v84/*: any*/),
    (v87/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v154 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v140/*: any*/),
  "storageKey": null
},
v155 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v156 = [
  (v155/*: any*/)
],
v157 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    (v99/*: any*/),
    (v73/*: any*/)
  ],
  "storageKey": null
},
v158 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v39/*: any*/),
        (v58/*: any*/),
        (v98/*: any*/),
        (v75/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v159 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v38/*: any*/),
        (v37/*: any*/),
        (v69/*: any*/),
        (v73/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v160 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    (v78/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v131/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v161 = {
  "kind": "InlineFragment",
  "selections": [
    (v96/*: any*/),
    (v82/*: any*/),
    (v83/*: any*/),
    (v89/*: any*/),
    (v159/*: any*/),
    (v139/*: any*/),
    (v160/*: any*/),
    (v142/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v162 = {
  "kind": "InlineFragment",
  "selections": [
    (v143/*: any*/),
    (v144/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v163 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v164 = [
  (v163/*: any*/)
],
v165 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "71"
    }
  }
],
v166 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v70/*: any*/),
    (v122/*: any*/),
    (v91/*: any*/),
    (v125/*: any*/)
  ],
  "storageKey": null
},
v167 = {
  "kind": "InlineFragment",
  "selections": [
    (v159/*: any*/),
    (v139/*: any*/),
    (v89/*: any*/),
    (v142/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v168 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    (v99/*: any*/),
    (v73/*: any*/),
    (v119/*: any*/),
    (v50/*: any*/),
    (v38/*: any*/),
    (v120/*: any*/),
    (v153/*: any*/)
  ],
  "storageKey": null
},
v169 = {
  "kind": "InlineFragment",
  "selections": [
    (v85/*: any*/),
    (v82/*: any*/),
    (v83/*: any*/),
    (v133/*: any*/),
    (v135/*: any*/),
    (v89/*: any*/),
    (v96/*: any*/),
    (v136/*: any*/),
    (v137/*: any*/),
    (v138/*: any*/),
    (v139/*: any*/),
    (v119/*: any*/),
    (v142/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v170 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v50/*: any*/),
        (v168/*: any*/),
        (v121/*: any*/),
        (v93/*: any*/),
        (v77/*: any*/),
        (v95/*: any*/),
        (v40/*: any*/),
        (v154/*: any*/),
        (v41/*: any*/),
        (v97/*: any*/),
        (v128/*: any*/),
        (v129/*: any*/),
        (v130/*: any*/),
        (v74/*: any*/),
        (v132/*: any*/),
        (v169/*: any*/),
        (v145/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v171 = [
  {
    "alias": null,
    "args": (v156/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v39/*: any*/),
              (v149/*: any*/),
              (v75/*: any*/),
              (v170/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "items(first:6)"
  },
  (v73/*: any*/)
],
v172 = [
  (v50/*: any*/),
  (v38/*: any*/),
  (v37/*: any*/),
  (v72/*: any*/),
  (v73/*: any*/)
],
v173 = [
  (v50/*: any*/),
  (v38/*: any*/),
  (v37/*: any*/),
  (v72/*: any*/),
  (v111/*: any*/),
  (v73/*: any*/)
],
v174 = [
  (v38/*: any*/),
  (v114/*: any*/)
],
v175 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "MAIN_IMAGE"
    }
  }
],
v176 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v177 = [
  (v176/*: any*/)
],
v178 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v110/*: any*/),
  "storageKey": null
},
v179 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "PUBLISHED_DATE"
  }
},
v180 = [
  (v38/*: any*/),
  (v37/*: any*/)
],
v181 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "wide_landscape"
    }
  }
],
v182 = {
  "alias": "size1280x720",
  "args": (v181/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v71/*: any*/),
  "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
},
v183 = {
  "kind": "Literal",
  "name": "exclude",
  "value": {
    "types": "VIDEO"
  }
},
v184 = [
  (v183/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v185 = {
  "alias": "size500x500",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "500x500"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v71/*: any*/),
  "storageKey": "style(filter:{\"style\":\"500x500\"})"
},
v186 = [
  (v119/*: any*/)
],
v187 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v39/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      (v38/*: any*/),
                      (v54/*: any*/),
                      (v73/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          (v37/*: any*/),
                          (v50/*: any*/),
                          (v78/*: any*/),
                          (v80/*: any*/),
                          (v81/*: any*/),
                          (v84/*: any*/),
                          (v87/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      }
                    ],
                    "storageKey": null
                  },
                  (v40/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v70/*: any*/),
                      (v122/*: any*/),
                      (v91/*: any*/),
                      (v182/*: any*/),
                      (v185/*: any*/),
                      (v124/*: any*/),
                      {
                        "alias": "size1200x1200",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "style": "1200x1200"
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v71/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"1200x1200\"})"
                      },
                      (v125/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*: any*/),
                  (v97/*: any*/),
                  (v158/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v37/*: any*/),
                      (v99/*: any*/),
                      (v73/*: any*/),
                      (v38/*: any*/),
                      (v120/*: any*/),
                      (v90/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v37/*: any*/),
                      (v54/*: any*/),
                      (v50/*: any*/),
                      (v78/*: any*/),
                      (v80/*: any*/),
                      (v81/*: any*/),
                      (v84/*: any*/),
                      (v131/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v136/*: any*/),
                      (v159/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          (v100/*: any*/),
                          (v37/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v89/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          (v50/*: any*/),
                          (v74/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": (v186/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v119/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  (v47/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v77/*: any*/),
                          (v103/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v186/*: any*/),
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  (v162/*: any*/)
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              }
            ],
            "type": "Article",
            "abstractKey": null
          },
          (v75/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v188 = [
  "exclude"
],
v189 = [
  {
    "alias": null,
    "args": (v184/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v187/*: any*/),
    "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:3)"
  },
  {
    "alias": null,
    "args": (v184/*: any*/),
    "filters": (v188/*: any*/),
    "handle": "connection",
    "key": "sectionStyleMainArticleListQueue__items",
    "kind": "LinkedHandle",
    "name": "items"
  },
  (v73/*: any*/)
],
v190 = [
  (v38/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "type": {
            "values": [
              "logo"
            ]
          }
        }
      }
    ],
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "images",
    "plural": true,
    "selections": (v71/*: any*/),
    "storageKey": "images(filter:{\"type\":{\"values\":[\"logo\"]}})"
  },
  (v73/*: any*/),
  (v134/*: any*/)
],
v191 = [
  (v183/*: any*/),
  (v147/*: any*/)
],
v192 = [
  {
    "alias": null,
    "args": (v191/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v187/*: any*/),
    "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:4)"
  },
  {
    "alias": null,
    "args": (v191/*: any*/),
    "filters": (v188/*: any*/),
    "handle": "connection",
    "key": "sectionStyleMainArticleListQueue__items",
    "kind": "LinkedHandle",
    "name": "items"
  },
  (v73/*: any*/)
],
v193 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v194 = {
  "alias": "size800x1200",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "portrait"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v71/*: any*/),
  "storageKey": "style(filter:{\"style\":\"portrait\"})"
},
v195 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v70/*: any*/),
    (v122/*: any*/),
    (v91/*: any*/),
    (v194/*: any*/)
  ],
  "storageKey": null
},
v196 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    (v99/*: any*/),
    (v73/*: any*/),
    (v50/*: any*/),
    (v38/*: any*/),
    (v120/*: any*/),
    (v153/*: any*/)
  ],
  "storageKey": null
},
v197 = {
  "alias": "size768x768",
  "args": (v92/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v71/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
},
v198 = {
  "kind": "InlineFragment",
  "selections": [
    (v89/*: any*/),
    (v159/*: any*/),
    (v139/*: any*/),
    (v142/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v36/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hooksTrackCurrentItemBase",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v39/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentArticleAtomBase",
                    "selections": [
                      (v39/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "articleHeadlineHeaderFeaturesContent",
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "args": (v43/*: any*/),
                            "kind": "FragmentSpread",
                            "name": "articleSeoArticle"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "articleShareWidgetArticle"
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "bookmarkHeaderFeaturesContent",
                            "selections": (v44/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "commentHeaderFeaturesArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "articleCommentsTriggerArticle"
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          (v45/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersCheckIsStyleArticle",
                            "selections": (v49/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersUseSharingUrl",
                            "selections": [
                              (v50/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksContentInterestArticle",
                            "selections": [
                              (v39/*: any*/),
                              (v37/*: any*/),
                              (v50/*: any*/),
                              (v52/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v53/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v51/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "hooksTrackPageViewArticle"
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUseCurrentArticleIdsArticle",
                            "selections": [
                              (v37/*: any*/),
                              (v54/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUseCurrentArticlePrebidConfigArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v57/*: any*/),
                                  (v52/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUsePageTargetingArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v59/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Topic",
                                    "kind": "LinkedField",
                                    "name": "firstTopic",
                                    "plural": false,
                                    "selections": (v51/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "onboardingNewsletterSubscriptionArticle",
                            "selections": [
                              (v60/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "entityLinkHeaderFeaturesArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v61/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v38/*: any*/),
                                              (v62/*: any*/),
                                              (v61/*: any*/)
                                            ],
                                            "type": "Section",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "shareHeaderFeaturesContent",
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "shareArticle20Content"
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "abandonedCartOfferDialogArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v59/*: any*/),
                                  (v52/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "args": (v43/*: any*/),
                    "argumentDefinitions": (v63/*: any*/)
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentShareContentAtomBase",
                    "selections": [
                      (v39/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v64/*: any*/),
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v64/*: any*/),
                        "type": "Video",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase",
                    "selections": [
                      (v39/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v57/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": (v55/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Section",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentTakeoverAdSectionsAtomBase",
                    "selections": [
                      (v39/*: any*/),
                      (v60/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": (v44/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Section",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "args": [
              (v42/*: any*/)
            ],
            "argumentDefinitions": (v63/*: any*/)
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "contextsSectionContextProviderSection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "sectionSeoSection"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSkipDefaultSectionQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v65/*: any*/),
              (v66/*: any*/),
              {
                "kind": "Variable",
                "name": "commentHarrySectionIds",
                "variableName": "commentHarrySectionIds"
              },
              {
                "kind": "Variable",
                "name": "commentQueueLimit",
                "variableName": "commentQueueLimit"
              },
              {
                "kind": "Variable",
                "name": "commentQueueName",
                "variableName": "commentQueueName"
              },
              {
                "kind": "Variable",
                "name": "dailyPulseTypeUuId",
                "variableName": "dailyPulseTypeUuId"
              },
              {
                "kind": "Variable",
                "name": "editorPicksQueueName",
                "variableName": "editorPicksQueueName"
              },
              (v35/*: any*/),
              {
                "kind": "Variable",
                "name": "focusQueueName",
                "variableName": "focusQueueName"
              },
              {
                "kind": "Variable",
                "name": "highlightQueueName",
                "variableName": "highlightQueueName"
              },
              {
                "kind": "Variable",
                "name": "includeAsiaDiscoveryWidget",
                "variableName": "includeAsiaDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includeChinaFutureTechDiscoveryWidget",
                "variableName": "includeChinaFutureTechDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includeChinaScienceDiscoveryWidget",
                "variableName": "includeChinaScienceDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includeComment",
                "variableName": "includeComment"
              },
              {
                "kind": "Variable",
                "name": "includeEditorPicks",
                "variableName": "includeEditorPicks"
              },
              {
                "kind": "Variable",
                "name": "includeFocusArticle",
                "variableName": "includeFocusArticle"
              },
              {
                "kind": "Variable",
                "name": "includeMostPopular",
                "variableName": "includeMostPopular"
              },
              {
                "kind": "Variable",
                "name": "includeMultimedia",
                "variableName": "includeMultimedia"
              },
              {
                "kind": "Variable",
                "name": "includeOpenQuestionsSeriesDiscoveryWidget",
                "variableName": "includeOpenQuestionsSeriesDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includePlus",
                "variableName": "includePlus"
              },
              {
                "kind": "Variable",
                "name": "includeThisWeekInAsiaDiscovery",
                "variableName": "includeThisWeekInAsiaDiscovery"
              },
              {
                "kind": "Variable",
                "name": "includeTrendingTopics",
                "variableName": "includeTrendingTopics"
              },
              {
                "kind": "Variable",
                "name": "mostPopularQueueName",
                "variableName": "mostPopularQueueName"
              },
              {
                "kind": "Variable",
                "name": "multimediaQueueName",
                "variableName": "multimediaQueueName"
              },
              {
                "kind": "Variable",
                "name": "plusNewsAgendaEndDate",
                "variableName": "plusNewsAgendaEndDate"
              },
              {
                "kind": "Variable",
                "name": "plusNewsAgendaStartDate",
                "variableName": "plusNewsAgendaStartDate"
              },
              {
                "kind": "Variable",
                "name": "plusNewsAgendaTypes",
                "variableName": "plusNewsAgendaTypes"
              },
              {
                "kind": "Variable",
                "name": "scmpPlusPaywallTypeIds",
                "variableName": "scmpPlusPaywallTypeIds"
              },
              {
                "kind": "Variable",
                "name": "sectionSpotlightQueueName",
                "variableName": "sectionSpotlightQueueName"
              },
              {
                "kind": "Variable",
                "name": "trendingTopicsQueueName",
                "variableName": "trendingTopicsQueueName"
              }
            ],
            "kind": "FragmentSpread",
            "name": "defaultSectionQuery"
          }
        ]
      },
      {
        "condition": "isStyleSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v66/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "sectionStyleContentQuery"
          }
        ]
      },
      {
        "condition": "isPostMagazineSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v66/*: any*/),
              (v35/*: any*/),
              {
                "kind": "Variable",
                "name": "sponsorQueueName",
                "variableName": "sponsorQueueName"
              }
            ],
            "kind": "FragmentSpread",
            "name": "sectionPostMagazineQuery"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v25/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v33/*: any*/),
      (v32/*: any*/),
      (v34/*: any*/),
      (v7/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Operation",
    "name": "sectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v36/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "version",
                "value": 2
              }
            ],
            "kind": "ScalarField",
            "name": "advertZone",
            "storageKey": "advertZone(version:2)"
          },
          (v69/*: any*/),
          (v54/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "type": "OG"
                }
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": (v71/*: any*/),
            "storageKey": "image(filter:{\"type\":\"OG\"})"
          },
          (v72/*: any*/),
          (v50/*: any*/),
          (v73/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v39/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v74/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v39/*: any*/),
                          (v56/*: any*/),
                          (v47/*: any*/),
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": (v76/*: any*/),
                    "storageKey": null
                  },
                  (v77/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": (v76/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleTypeSegment",
                        "kind": "LinkedField",
                        "name": "types",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleType",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v37/*: any*/),
                              (v73/*: any*/),
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v62/*: any*/),
                                  (v88/*: any*/)
                                ],
                                "type": "Section",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableOffPlatformContent",
                        "storageKey": null
                      },
                      (v89/*: any*/),
                      (v62/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          (v37/*: any*/),
                          (v90/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          {
                            "alias": "generic_og",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "style": "og_image_scmp_generic"
                                }
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v71/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "styles": [
                                    "og_postmag",
                                    "og_image_style",
                                    "og_image_scmp_analysis",
                                    "og_image_scmp_explainer",
                                    "og_image_scmp_editorial",
                                    "og_image_scmp_fact_check",
                                    "og_image_scmp_live",
                                    "og_image_scmp_obituary",
                                    "og_image_scmp_opinion",
                                    "og_image_scmp_review",
                                    "og_image_scmp_series",
                                    "og_image_scmp_generic"
                                  ]
                                }
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "styles",
                            "plural": true,
                            "selections": [
                              (v70/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "style",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "styles(filter:{\"styles\":[\"og_postmag\",\"og_image_style\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
                          },
                          (v91/*: any*/),
                          {
                            "alias": null,
                            "args": (v92/*: any*/),
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v71/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"768x768\"})"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSlideshow",
                            "storageKey": null
                          },
                          (v70/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v93/*: any*/),
                      (v94/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormattedValue",
                        "kind": "LinkedField",
                        "name": "subHeadline",
                        "plural": false,
                        "selections": (v68/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v42/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "PARAGRAPH"
                          }
                        ],
                        "concreteType": "FormattedValue",
                        "kind": "LinkedField",
                        "name": "body",
                        "plural": false,
                        "selections": (v68/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "keywords",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      (v95/*: any*/),
                      (v96/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleSpeech",
                        "kind": "LinkedField",
                        "name": "articleSpeeches",
                        "plural": true,
                        "selections": [
                          (v70/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "country",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "gender",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "voiceName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v97/*: any*/),
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "firstTopic",
                        "plural": false,
                        "selections": (v76/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v98/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v99/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v69/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v101/*: any*/),
                              (v85/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v103/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  (v103/*: any*/)
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v39/*: any*/),
                          (v56/*: any*/),
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Article",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "fullSectionPath",
                    "plural": true,
                    "selections": [
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v73/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Section",
                "abstractKey": null
              }
            ],
            "type": "BaseWithApplicationAndUrlAlias",
            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyValuePair",
                "kind": "LinkedField",
                "name": "metatags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DynamicMetaTags",
            "abstractKey": "__isDynamicMetaTags"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSkipDefaultSectionQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v36/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "subSections",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              (v104/*: any*/),
                              (v106/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v105/*: any*/),
                                "type": "VideoSection",
                                "abstractKey": null
                              },
                              (v107/*: any*/),
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v108/*: any*/),
                  (v73/*: any*/)
                ],
                "storageKey": null
              },
              (v111/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "description",
                "plural": false,
                "selections": (v113/*: any*/),
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v116/*: any*/),
                  (v117/*: any*/)
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "topStories",
            "args": (v118/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 17
                  }
                ],
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v37/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v37/*: any*/),
                                  (v99/*: any*/),
                                  (v73/*: any*/),
                                  (v119/*: any*/),
                                  (v50/*: any*/),
                                  (v38/*: any*/),
                                  (v120/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v39/*: any*/),
                                      (v54/*: any*/),
                                      (v78/*: any*/),
                                      (v80/*: any*/),
                                      (v81/*: any*/),
                                      (v84/*: any*/),
                                      (v87/*: any*/),
                                      (v116/*: any*/),
                                      (v117/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v121/*: any*/),
                              (v93/*: any*/),
                              (v77/*: any*/),
                              (v95/*: any*/),
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v70/*: any*/),
                                  (v122/*: any*/),
                                  (v91/*: any*/),
                                  (v124/*: any*/),
                                  (v125/*: any*/),
                                  (v126/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              (v97/*: any*/),
                              (v128/*: any*/),
                              (v129/*: any*/),
                              (v130/*: any*/),
                              (v74/*: any*/),
                              (v132/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v85/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  (v133/*: any*/),
                                  (v135/*: any*/),
                                  (v89/*: any*/),
                                  (v96/*: any*/),
                                  (v136/*: any*/),
                                  (v137/*: any*/),
                                  (v138/*: any*/),
                                  (v139/*: any*/),
                                  (v119/*: any*/),
                                  (v141/*: any*/),
                                  (v142/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              (v145/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:17)"
              },
              (v73/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "spotlightQueue",
            "args": (v146/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v148/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v150/*: any*/),
                "storageKey": "items(first:4)"
              },
              (v73/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "commentQueue",
            "args": (v151/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v152/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v150/*: any*/),
                "storageKey": null
              },
              (v73/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sectionSpotlightQueue",
            "args": (v146/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v148/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v37/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v37/*: any*/),
                                  (v99/*: any*/),
                                  (v73/*: any*/),
                                  (v50/*: any*/),
                                  (v38/*: any*/),
                                  (v120/*: any*/),
                                  (v119/*: any*/),
                                  (v153/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v121/*: any*/),
                              (v93/*: any*/),
                              (v77/*: any*/),
                              (v95/*: any*/),
                              (v40/*: any*/),
                              (v154/*: any*/),
                              (v41/*: any*/),
                              (v97/*: any*/),
                              (v128/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "summary",
                                "plural": false,
                                "selections": [
                                  (v67/*: any*/),
                                  (v112/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v129/*: any*/),
                              (v74/*: any*/),
                              (v132/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v85/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  (v133/*: any*/),
                                  (v135/*: any*/),
                                  (v89/*: any*/),
                                  (v96/*: any*/),
                                  (v136/*: any*/),
                                  (v137/*: any*/),
                                  (v138/*: any*/),
                                  (v141/*: any*/),
                                  (v139/*: any*/),
                                  (v119/*: any*/),
                                  (v142/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v143/*: any*/),
                                  (v144/*: any*/),
                                  (v102/*: any*/)
                                ],
                                "type": "Video",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:4)"
              },
              (v73/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "advertConfig",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "scmp_pwa_advert_campaign"
                }
              }
            ],
            "concreteType": "AppConfigs",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": (v113/*: any*/),
            "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_advert_campaign\"})"
          },
          {
            "alias": "postMagazineLast7Days",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "scmp_trending_section_scmp_trending_section_postmag_last_7_days"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v156/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v50/*: any*/),
                                  (v157/*: any*/),
                                  (v40/*: any*/),
                                  (v154/*: any*/),
                                  (v41/*: any*/),
                                  (v97/*: any*/),
                                  (v158/*: any*/),
                                  (v94/*: any*/),
                                  (v95/*: any*/),
                                  (v161/*: any*/),
                                  (v160/*: any*/),
                                  (v162/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v73/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"})"
          },
          {
            "alias": "postMagazineSponsor",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "discovery_module_discovery_module_71"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v164/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v50/*: any*/),
                                  (v157/*: any*/),
                                  (v40/*: any*/),
                                  (v154/*: any*/),
                                  (v41/*: any*/),
                                  (v97/*: any*/),
                                  (v158/*: any*/),
                                  (v94/*: any*/),
                                  (v95/*: any*/),
                                  (v161/*: any*/),
                                  (v160/*: any*/),
                                  (v162/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:1)"
              },
              (v73/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"discovery_module_discovery_module_71\"})"
          },
          {
            "alias": "postMagazineSection",
            "args": (v165/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v73/*: any*/),
              (v134/*: any*/)
            ],
            "storageKey": "section(filter:{\"entityId\":\"71\"})"
          },
          {
            "condition": "includeEditorPicks",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "sectionEditorPicks",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "editorPicksQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v156/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v50/*: any*/),
                                  (v40/*: any*/),
                                  (v166/*: any*/),
                                  (v41/*: any*/),
                                  (v97/*: any*/),
                                  (v158/*: any*/),
                                  (v157/*: any*/),
                                  (v132/*: any*/),
                                  (v167/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:6)"
                  },
                  (v73/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeAsiaDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "asiaQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_3"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v171/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_3\"})"
              },
              {
                "alias": "asiaSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "3"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v172/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"3\"})"
              }
            ]
          },
          {
            "condition": "includeChinaFutureTechDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "chinaFutureTechQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_519735"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v171/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_519735\"})"
              },
              {
                "alias": "chinaFutureTechSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "519735"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v173/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"519735\"})"
              }
            ]
          },
          {
            "condition": "includeChinaScienceDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "chinaScienceQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_328475"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v171/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_328475\"})"
              },
              {
                "alias": "chinaScienceSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "328475"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v172/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"328475\"})"
              }
            ]
          },
          {
            "condition": "includeThisWeekInAsiaDiscovery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "twiaQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_323045"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v171/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
              },
              {
                "alias": "twiaSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "323045"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v173/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"323045\"})"
              }
            ]
          },
          {
            "condition": "includeComment",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "commentSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "93"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  (v50/*: any*/),
                  (v73/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v37/*: any*/),
                      (v58/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v174/*: any*/),
                        "type": "Author",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v174/*: any*/),
                        "type": "Topic",
                        "abstractKey": null
                      }
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  }
                ],
                "storageKey": "section(filter:{\"entityId\":\"93\"})"
              },
              {
                "alias": "commentQueue",
                "args": (v151/*: any*/),
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v152/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v50/*: any*/),
                                  (v121/*: any*/),
                                  (v93/*: any*/),
                                  (v77/*: any*/),
                                  (v95/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      (v37/*: any*/),
                                      (v54/*: any*/),
                                      (v38/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "type": "AUTHOR_IMAGE"
                                            }
                                          }
                                        ],
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                  "style": "300x300"
                                                }
                                              }
                                            ],
                                            "concreteType": "ImageStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": (v71/*: any*/),
                                            "storageKey": "style(filter:{\"style\":\"300x300\"})"
                                          }
                                        ],
                                        "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                                      },
                                      (v73/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v39/*: any*/),
                                          (v50/*: any*/),
                                          (v78/*: any*/),
                                          (v80/*: any*/),
                                          (v81/*: any*/),
                                          (v84/*: any*/),
                                          (v87/*: any*/)
                                        ],
                                        "type": "BaseWithApplicationAndUrlAlias",
                                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v97/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v158/*: any*/),
                                  (v157/*: any*/),
                                  (v132/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v96/*: any*/),
                                      (v136/*: any*/),
                                      (v137/*: any*/),
                                      (v138/*: any*/),
                                      (v101/*: any*/),
                                      (v89/*: any*/),
                                      (v142/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v143/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v175/*: any*/),
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "alt",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": (v123/*: any*/),
                                            "concreteType": "ImageStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": (v71/*: any*/),
                                            "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                          }
                                        ],
                                        "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                                      }
                                    ],
                                    "type": "Video",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeMostPopular",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "mostPopularQueueQuery",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "mostPopularQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v177/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v50/*: any*/),
                                  (v168/*: any*/),
                                  (v121/*: any*/),
                                  (v93/*: any*/),
                                  (v77/*: any*/),
                                  (v95/*: any*/),
                                  (v40/*: any*/),
                                  (v154/*: any*/),
                                  (v41/*: any*/),
                                  (v97/*: any*/),
                                  (v128/*: any*/),
                                  (v129/*: any*/),
                                  (v130/*: any*/),
                                  (v74/*: any*/),
                                  (v132/*: any*/),
                                  (v169/*: any*/),
                                  (v145/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:5)"
                  },
                  (v73/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeMultimedia",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "multimedia",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "multimediaQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v148/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v76/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v50/*: any*/),
                                  (v40/*: any*/),
                                  (v154/*: any*/),
                                  (v41/*: any*/),
                                  (v97/*: any*/),
                                  (v158/*: any*/),
                                  (v157/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "images",
                                        "plural": true,
                                        "selections": [
                                          (v39/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Gallery",
                                    "abstractKey": null
                                  },
                                  (v132/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleTypeSegment",
                                        "kind": "LinkedField",
                                        "name": "types",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ArticleType",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": [
                                              (v37/*: any*/),
                                              (v69/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SectionSegmentV2",
                                        "kind": "LinkedField",
                                        "name": "sectionsV2",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": [
                                              (v39/*: any*/),
                                              (v58/*: any*/),
                                              (v75/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v139/*: any*/),
                                      (v89/*: any*/),
                                      (v178/*: any*/),
                                      (v142/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  (v162/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PodcastSection",
                                        "kind": "LinkedField",
                                        "name": "podcastSections",
                                        "plural": true,
                                        "selections": [
                                          (v178/*: any*/),
                                          (v38/*: any*/),
                                          (v73/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Podcast",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:4)"
                  },
                  (v73/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeTrendingTopics",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "trendingTopicsQueue",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "trendingTopicsQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v177/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v38/*: any*/),
                                  (v37/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v54/*: any*/),
                                      (v50/*: any*/),
                                      (v78/*: any*/),
                                      (v80/*: any*/),
                                      (v81/*: any*/),
                                      (v84/*: any*/),
                                      (v87/*: any*/),
                                      (v116/*: any*/),
                                      (v117/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "type": "Topic",
                                "abstractKey": null
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:5)"
                  },
                  (v73/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includePlus",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "dailyPulseQuery",
                "args": [
                  {
                    "fields": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "typeIds.0",
                            "variableName": "dailyPulseTypeUuId"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "typeIds"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v163/*: any*/),
                  (v179/*: any*/)
                ],
                "concreteType": "ArticleConnection",
                "kind": "LinkedField",
                "name": "articles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Article",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v50/*: any*/),
                          (v73/*: any*/),
                          (v153/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v39/*: any*/),
                              (v97/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v39/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v180/*: any*/),
                                        "type": "Section",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v180/*: any*/),
                                        "type": "VideoSection",
                                        "abstractKey": null
                                      },
                                      (v75/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v157/*: any*/),
                              (v121/*: any*/),
                              (v77/*: any*/),
                              (v93/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v159/*: any*/),
                                  (v139/*: any*/),
                                  (v89/*: any*/),
                                  (v85/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "highlightQueue",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "highlightQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 2
                      }
                    ],
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v50/*: any*/),
                                  (v40/*: any*/),
                                  (v166/*: any*/),
                                  (v41/*: any*/),
                                  (v97/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v39/*: any*/),
                                          (v127/*: any*/),
                                          (v58/*: any*/),
                                          (v98/*: any*/),
                                          (v75/*: any*/),
                                          (v107/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v157/*: any*/),
                                  (v132/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v85/*: any*/),
                                      (v137/*: any*/),
                                      (v139/*: any*/),
                                      (v89/*: any*/),
                                      (v142/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:2)"
                  },
                  (v73/*: any*/),
                  (v108/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v65/*: any*/),
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "endDate",
                            "variableName": "plusNewsAgendaEndDate"
                          },
                          {
                            "kind": "Variable",
                            "name": "startDate",
                            "variableName": "plusNewsAgendaStartDate"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "newsAgendaDateRange"
                      },
                      {
                        "kind": "Literal",
                        "name": "newsAgendaOptions",
                        "value": [
                          "key_event"
                        ]
                      },
                      {
                        "kind": "Variable",
                        "name": "types",
                        "variableName": "plusNewsAgendaTypes"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v176/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "ASC",
                      "field": "NEWS_AGENDA_START_DATE"
                    }
                  }
                ],
                "concreteType": "TopicConnection",
                "kind": "LinkedField",
                "name": "topics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TopicEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v50/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NewsAgenda",
                            "kind": "LinkedField",
                            "name": "newsAgenda",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "secondaryDescription",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "time",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "newsAgendaOptions",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v69/*: any*/),
                          (v93/*: any*/),
                          (v73/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "scmp_pwa_settings"
                    }
                  }
                ],
                "concreteType": "AppConfigs",
                "kind": "LinkedField",
                "name": "appConfig",
                "plural": false,
                "selections": (v113/*: any*/),
                "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
              }
            ]
          },
          {
            "condition": "includeFocusArticle",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "focus",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "focusQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  {
                    "alias": null,
                    "args": (v164/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v40/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v70/*: any*/),
                                      (v122/*: any*/),
                                      (v91/*: any*/),
                                      (v182/*: any*/),
                                      {
                                        "alias": "size640x360",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "wide_landscape_640_360"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v71/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"wide_landscape_640_360\"})"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v41/*: any*/),
                                  (v97/*: any*/),
                                  (v158/*: any*/),
                                  (v157/*: any*/),
                                  (v50/*: any*/),
                                  (v132/*: any*/),
                                  (v162/*: any*/),
                                  (v167/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v79/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v39/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v37/*: any*/),
                                              (v38/*: any*/),
                                              (v50/*: any*/),
                                              {
                                                "alias": null,
                                                "args": (v109/*: any*/),
                                                "concreteType": "Image",
                                                "kind": "LinkedField",
                                                "name": "image",
                                                "plural": false,
                                                "selections": (v110/*: any*/),
                                                "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
                                              }
                                            ],
                                            "type": "Section",
                                            "abstractKey": null
                                          },
                                          (v75/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v82/*: any*/),
                                  (v83/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v39/*: any*/),
                                          (v47/*: any*/),
                                          (v75/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Video",
                                "abstractKey": null
                              },
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:1)"
                  },
                  (v73/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeOpenQuestionsSeriesDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "openQuestionSeriesTopic",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "518656"
                    }
                  }
                ],
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": [
                  (v38/*: any*/),
                  (v50/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "paywallTypeIds",
                            "variableName": "scmpPlusPaywallTypeIds"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "exclude"
                      },
                      (v155/*: any*/),
                      (v179/*: any*/)
                    ],
                    "concreteType": "ContentConnection",
                    "kind": "LinkedField",
                    "name": "contents",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              (v73/*: any*/),
                              (v170/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v73/*: any*/)
                ],
                "storageKey": "topic(filter:{\"entityId\":\"518656\"})"
              }
            ]
          }
        ]
      },
      {
        "condition": "isStyleSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "topArticleQueue",
            "args": (v118/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v189/*: any*/),
            "storageKey": null
          },
          {
            "alias": "luxurySection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "322897"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v190/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"322897\"})"
          },
          {
            "alias": "luxuryArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_322897"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v192/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_322897\"})"
          },
          {
            "alias": "fashionSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516294"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v190/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516294\"})"
          },
          {
            "alias": "fashionArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516294"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v192/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516294\"})"
          },
          {
            "alias": "beautySection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516298"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v190/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516298\"})"
          },
          {
            "alias": "beautyArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516298"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v189/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516298\"})"
          },
          {
            "alias": "peopleSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516301"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v190/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516301\"})"
          },
          {
            "alias": "peopleArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516301"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v189/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516301\"})"
          },
          {
            "alias": "lifestyleSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516305"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v190/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516305\"})"
          },
          {
            "alias": "lifestyleArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516305"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v189/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516305\"})"
          },
          {
            "alias": "fashionCarousel",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "style_fashion_carousel"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          (v193/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v195/*: any*/),
                              (v41/*: any*/),
                              (v97/*: any*/),
                              (v158/*: any*/),
                              (v196/*: any*/),
                              (v88/*: any*/),
                              (v167/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v73/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"style_fashion_carousel\"})"
          },
          {
            "alias": "spotlight",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "4335"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          (v193/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v195/*: any*/),
                              (v41/*: any*/),
                              (v97/*: any*/),
                              (v158/*: any*/),
                              (v157/*: any*/),
                              (v88/*: any*/),
                              (v167/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v73/*: any*/)
            ],
            "storageKey": "queue(filter:{\"entityId\":\"4335\"})"
          },
          {
            "alias": "styleVideoSectionPicksQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "video_section_picks_323289"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v164/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v143/*: any*/),
                              (v37/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": (v175/*: any*/),
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": (v181/*: any*/),
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v71/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                                  }
                                ],
                                "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                              },
                              (v102/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VideoSource",
                                "kind": "LinkedField",
                                "name": "videoSource",
                                "plural": true,
                                "selections": [
                                  (v73/*: any*/),
                                  (v91/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Video",
                            "abstractKey": null
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:1)"
              },
              (v73/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"video_section_picks_323289\"})"
          }
        ]
      },
      {
        "condition": "isPostMagazineSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "postMagSection",
            "args": (v165/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v50/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "subSections",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              (v104/*: any*/),
                              (v106/*: any*/),
                              (v107/*: any*/),
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v73/*: any*/)
                ],
                "storageKey": null
              },
              (v73/*: any*/)
            ],
            "storageKey": "section(filter:{\"entityId\":\"71\"})"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "322743"
                }
              }
            ],
            "concreteType": "Newsletter",
            "kind": "LinkedField",
            "name": "newsletter",
            "plural": false,
            "selections": [
              (v69/*: any*/),
              (v94/*: any*/),
              (v73/*: any*/)
            ],
            "storageKey": "newsletter(filter:{\"entityId\":\"322743\"})"
          },
          {
            "alias": "leadStoryPostMagQueue",
            "args": (v118/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v156/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v37/*: any*/),
                              (v50/*: any*/),
                              (v196/*: any*/),
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v70/*: any*/),
                                  (v122/*: any*/),
                                  (v91/*: any*/),
                                  (v124/*: any*/),
                                  (v197/*: any*/),
                                  (v125/*: any*/),
                                  (v194/*: any*/),
                                  (v185/*: any*/),
                                  (v126/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              (v97/*: any*/),
                              (v158/*: any*/),
                              (v94/*: any*/),
                              (v132/*: any*/),
                              (v198/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v73/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sponsorQueue",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "sponsorQueueName"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v156/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v37/*: any*/),
                              (v50/*: any*/),
                              (v196/*: any*/),
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v70/*: any*/),
                                  (v122/*: any*/),
                                  (v91/*: any*/),
                                  (v124/*: any*/),
                                  (v197/*: any*/),
                                  (v125/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              (v97/*: any*/),
                              (v158/*: any*/),
                              (v132/*: any*/),
                              (v198/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v75/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v73/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0c1526458c6e914289e2b6f79030fcde",
    "id": null,
    "metadata": {},
    "name": "sectionPageQuery",
    "operationKind": "query",
    "text": "query sectionPageQuery(\n  $applicationId: String!\n  $articlesQueueName: String!\n  $commentQueueName: String!\n  $commentQueueLimit: Int!\n  $customContents: [CustomContentInput]\n  $dailyPulseTypeUuId: String!\n  $entityId: String!\n  $focusQueueName: String!\n  $highlightQueueName: String!\n  $isStyleSection: Boolean!\n  $isPostMagazineSection: Boolean!\n  $isSkipDefaultSectionQuery: Boolean!\n  $mostPopularQueueName: String!\n  $multimediaQueueName: String!\n  $plusNewsAgendaEndDate: Timestamp!\n  $plusNewsAgendaStartDate: Timestamp!\n  $plusNewsAgendaTypes: [String]!\n  $scmpPlusPaywallTypeIds: [String]\n  $sponsorQueueName: String!\n  $sectionSpotlightQueueName: String!\n  $trendingTopicsQueueName: String!\n  $editorPicksQueueName: String!\n  $includeAsiaDiscoveryWidget: Boolean!\n  $includeChinaFutureTechDiscoveryWidget: Boolean!\n  $includeChinaScienceDiscoveryWidget: Boolean!\n  $includeComment: Boolean!\n  $includeFocusArticle: Boolean!\n  $includeMostPopular: Boolean!\n  $includeMultimedia: Boolean!\n  $includeOpenQuestionsSeriesDiscoveryWidget: Boolean!\n  $includePlus: Boolean!\n  $includeThisWeekInAsiaDiscovery: Boolean!\n  $includeTrendingTopics: Boolean!\n  $includeEditorPicks: Boolean!\n) {\n  section(filter: {entityId: $entityId}) {\n    entityId\n    name\n    ...hooksTrackCurrentItemBase_4oKxOH\n    ...contextsSectionContextProviderSection\n    ...sectionSeoSection\n    id\n  }\n  ...defaultSectionQuery_1u0CaU @skip(if: $isSkipDefaultSectionQuery)\n  ...sectionStyleContentQuery_jhigl @include(if: $isStyleSection)\n  ...sectionPostMagazineQuery_GVfS0 @include(if: $isPostMagazineSection)\n}\n\nfragment abandonedCartOfferDialogArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n  ...helpersUseContentSponsorContent\n}\n\nfragment articleHeadlineHeaderFeaturesContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n}\n\nfragment articleSeoArticle_3GTCBR on Article {\n  ...hooksArticleSeoArticle\n  ...helpersGetArticleTypeArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: $customContents, type: PARAGRAPH) {\n    text\n  }\n  keywords\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  readingTime\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  articleSpeeches {\n    url\n  }\n  ...genericArticleSpeechInlineWidgetGenericArticle\n}\n\nfragment asiaDiscoveryWidgetQuery on Query {\n  asiaSection: section(filter: {entityId: \"3\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  asiaQueue: queue(filter: {name: \"section_top_3\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment atomsCurrentArticleAtomBase_3GTCBR on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Content {\n    __isContent: __typename\n    ...articleHeadlineHeaderFeaturesContent\n    ...articleSeoArticle_3GTCBR\n    ...articleShareWidgetArticle\n    ...bookmarkHeaderFeaturesContent\n    ...commentHeaderFeaturesArticle\n    ...contentShareWidgetContent\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...hooksContentInterestArticle\n    ...hooksTrackPageViewArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseCurrentArticlePrebidConfigArticle\n    ...hooksUsePageTargetingArticle\n    ...onboardingNewsletterSubscriptionArticle\n    ...entityLinkHeaderFeaturesArticle\n    ...shareHeaderFeaturesContent\n    ...abandonedCartOfferDialogArticle\n  }\n}\n\nfragment atomsCurrentShareContentAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...contentShareWidgetContent\n  }\n  ... on Video {\n    ...contentShareWidgetContent\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n  entityUuid\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment bookmarkHeaderFeaturesContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n  articleSpeeches {\n    country\n    gender\n    url\n    voiceName\n  }\n  images {\n    isSlideshow\n    url\n  }\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment chinaFutureTechDiscoveryWidgetQuery on Query {\n  chinaFutureTechSection: section(filter: {entityId: \"519735\"}) {\n    ...latestDiscoveryWidgetSection\n    ...sectionTermLogoSection\n    urlAlias\n    name\n    id\n  }\n  chinaFutureTechQueue: queue(filter: {name: \"section_top_519735\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment chinaScienceDiscoveryWidgetQuery on Query {\n  chinaScienceSection: section(filter: {entityId: \"328475\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment commentContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2RX0zR\n  ... on Video {\n    headline\n    duration\n    image(filter: {type: MAIN_IMAGE}) {\n      alt\n      style(filter: {style: \"1200x800\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment commentHeaderFeaturesArticle on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment commentQueueQuery_1samWO on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    ...followButtonBase\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: $commentQueueLimit) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAgendaContentTopic on Topic {\n  newsAgenda {\n    secondaryDescription\n  }\n  description {\n    text\n  }\n  updatedDate\n  name\n  ...hooksNewsAgendaTopic\n}\n\nfragment contentAuthorImageContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    entityUuid\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent_1X8xbh on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_1pemU3 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_1tYcF5 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_246nsq on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2DVJWQ on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n  }\n}\n\nfragment contentCoverImageContent_2UpXRA on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size1200x1200: style(filter: {style: \"1200x1200\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2vIMe6 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3CHIH7 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size800x1200: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3MAHTt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3Xh6CG on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size800x1200: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4Kx38 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_aft1q on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_wy32c on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size640x360: style(filter: {style: \"wide_landscape_640_360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverVideoContent on Content {\n  __isContent: __typename\n  ... on Article {\n    multimediaEmbed {\n      json\n    }\n    ...contentSchemaRenderContent\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentReadingTimeContent on Content {\n  __isContent: __typename\n  readingTime\n  flag\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment contextsSectionContextProviderSection on Section {\n  ...hooksUseSectionBaseAdvertisingInfoSection\n}\n\nfragment defaultSectionQuery_1u0CaU on Query {\n  section(filter: {entityId: $entityId}) {\n    name\n    entityId\n    advertZone(version: 2)\n    subSections {\n      items {\n        edges {\n          ...entityOnelineMenuLiteQueueItemsEdge\n        }\n      }\n      settings\n      id\n    }\n    ...sectionTermLogoSection\n    ...sectionDescriptionSection\n    ...entityFollowButtonBase\n    id\n  }\n  topStories: queue(filter: {name: $articlesQueueName}) {\n    items(first: 17) {\n      edges {\n        ...oneSectionTopWidgetQueue\n        ...topStoriesBlockQueueItemsEdge\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  sectionEditorPicks: queue(filter: {name: $editorPicksQueueName}) @include(if: $includeEditorPicks) {\n    items(first: 6) {\n      edges {\n        ...sectionEditorPicksQueue\n      }\n    }\n    id\n  }\n  spotlightQueue: queue(filter: {name: $sectionSpotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: $commentQueueLimit) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  asiaQueue: queue(filter: {name: \"section_top_3\"}) @include(if: $includeAsiaDiscoveryWidget) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  chinaFutureTechQueue: queue(filter: {name: \"section_top_519735\"}) @include(if: $includeChinaFutureTechDiscoveryWidget) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) @include(if: $includeChinaScienceDiscoveryWidget) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  twiaQueue: queue(filter: {name: \"section_top_323045\"}) @include(if: $includeThisWeekInAsiaDiscovery) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  ...sectionNewsletterWidgetQuery_49mQWb\n  ...sectionSpotlightQuery_S3w6I\n  ...hooksSectionWidgetQuery_43OK7R\n}\n\nfragment discoveryWidgetPostMagazineQueueQuery on Query {\n  postMagazineLast7Days: queue(filter: {name: \"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSponsor: queue(filter: {name: \"discovery_module_discovery_module_71\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSection: section(filter: {entityId: \"71\"}) {\n    ...entityLink\n    id\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityLinkHeaderFeaturesArticle on Article {\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n        ...entityLink\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment entityOnelineMenuLiteQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ... on VideoSection {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityOnelineMenuQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment focusArticleHomeFocusArticleQuery_4COOKT on Query {\n  focus: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ...homeFocusContentItemContent\n          ...helpersGetArticleTitleArticle\n          ...helpersGetPodcastTitlePodcast\n          ...helpersGetVideoTitleVideo\n          ...helpersCheckIsLiveArticle\n          ...helpersGetArticleLogoArticle\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  articleSpeeches {\n    url\n  }\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n}\n\nfragment headerPostMagazineQuery on Query {\n  postMagSection: section(filter: {entityId: \"71\"}) {\n    urlAlias\n    subSections {\n      items {\n        edges {\n          ...entityOnelineMenuQueueItemsEdge\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsAmpEnabledArticle on Article {\n  entityId\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  disableOffPlatformContent\n  sponsorType\n  published\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleLogoArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n        urlAlias\n        image(filter: {type: TERM_LOGO}) {\n          style(filter: {style: \"100x100\"}) {\n            url\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTitleArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetLabelContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Gallery {\n    __typename\n  }\n  ... on Video {\n    __typename\n  }\n}\n\nfragment helpersGetPodcastTitlePodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetVideoTitleVideo on Video {\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetVideoYoutubeIdVideo on Video {\n  youtubeId\n  videoSource {\n    id\n    type\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment homeFocusContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ... on Video {\n    duration\n  }\n  ...hooksContentItemProvidersContent_Q7hCx\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3LgACx\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksContentHeadlineTagContent\n  ...helpersCheckIsAmpEnabledArticle\n  entityId\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_postmag\", \"og_image_style\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  topics {\n    name\n    id\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksContentItemProvidersContent_14w7Xi on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentReadingTimeContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1WHnPc on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2DVJWQ\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1YIyJs on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1pemU3\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2Mm1vQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2RX0zR on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2zd4GF on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3CHIH7\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3LgACx on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1tYcF5\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3SIuYu on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3hlRa7 on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3Xh6CG\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3k6QDo on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3CHIH7\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_4hutWY on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2UpXRA\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_9hDaW on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1X8xbh\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_JIVKo on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_246nsq\n  ...contentCoverVideoContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Q7hCx on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_wy32c\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_gwnn5 on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2vIMe6\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksNewsAgendaTopic on Topic {\n  newsAgenda {\n    startDate\n    endDate\n    time\n    newsAgendaOptions\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksPlusArticleLinkHandlerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  id\n  entityId\n  urlAlias\n}\n\nfragment hooksPlusWidgetConfigQuery on Query {\n  appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n  }\n}\n\nfragment hooksSectionWidgetQuery_43OK7R on Query {\n  advertConfig: appConfig(filter: {entityId: \"scmp_pwa_advert_campaign\"}) {\n    json\n  }\n  section(filter: {entityId: $entityId}) {\n    entityId\n    advertZone(version: 2)\n    id\n  }\n  ...thisWeekInAsiaDiscoveryWidgetQuery @include(if: $includeThisWeekInAsiaDiscovery)\n  ...commentQueueQuery_1samWO @include(if: $includeComment)\n  ...discoveryWidgetPostMagazineQueueQuery\n  ...mostPopularQueueQuery_KkbCb @include(if: $includeMostPopular)\n  ...multimediaQuery_4rBIay @include(if: $includeMultimedia)\n  ...trendingTopicTopic_4tMn4o @include(if: $includeTrendingTopics)\n  ...plusWidgetQuery_1YyBVf @include(if: $includePlus)\n  ...asiaDiscoveryWidgetQuery @include(if: $includeAsiaDiscoveryWidget)\n  ...chinaScienceDiscoveryWidgetQuery @include(if: $includeChinaScienceDiscoveryWidget)\n  ...chinaFutureTechDiscoveryWidgetQuery @include(if: $includeChinaFutureTechDiscoveryWidget)\n  ...focusArticleHomeFocusArticleQuery_4COOKT @include(if: $includeFocusArticle)\n  ...openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo @include(if: $includeOpenQuestionsSeriesDiscoveryWidget)\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...hooksPaywallPromiseContent\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTrackCurrentItemBase_4oKxOH on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_3GTCBR\n  ...atomsCurrentShareContentAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n  headline\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  entityUuid\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Content {\n  __isContent: __typename\n  entityId\n  entityUuid\n}\n\nfragment hooksUseCurrentArticlePrebidConfigArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksUseDeepLinkTagsBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  urlAlias\n  entityId\n}\n\nfragment hooksUseDynamicMetaTags on DynamicMetaTags {\n  __isDynamicMetaTags: __typename\n  metatags {\n    key\n    value\n  }\n}\n\nfragment hooksUsePageTargetingArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  firstTopic {\n    name\n    id\n  }\n}\n\nfragment hooksUseSectionBaseAdvertisingInfoSection on Section {\n  advertZone(version: 2)\n  entityId\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment itemAgendaItemTopic on Topic {\n  urlAlias\n  newsAgenda {\n    startDate\n  }\n  entityId\n  name\n  ...contentAgendaContentTopic\n  ...hooksNewsAgendaTopic\n}\n\nfragment latestDiscoveryWidgetQueue on Queue {\n  items(first: 6) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          entityId\n          ...homeSecondaryContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetSection on Section {\n  urlAlias\n  name\n  entityId\n  parentSection\n}\n\nfragment leadStoryPostMagazineContent on Content {\n  __isContent: __typename\n  ...postMagazineLeadContentItemContent\n}\n\nfragment magazinesStyleCardContentItemContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    ...topicLinkTopic\n    id\n  }\n  ...entityLink\n  ...helpersCheckIsMainTopicContent\n  ...hooksContentItemProvidersContent_4hutWY\n}\n\nfragment magazinesStyleFashionCarouselContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...hooksContentItemProvidersContent_2zd4GF\n}\n\nfragment magazinesStyleLeadContentItemContent on Content {\n  __isContent: __typename\n  authors {\n    ...authorNameAuthor\n    id\n  }\n  ...entityLink\n  ...helpersIsArticleVideoAsHeroArticle\n  ...hooksContentItemProvidersContent_JIVKo\n}\n\nfragment magazinesStyleSpotlightContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ...hooksContentItemProvidersContent_3k6QDo\n}\n\nfragment mostPopularQueueQuery_KkbCb on Query {\n  mostPopularQueueQuery: queue(filter: {name: $mostPopularQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment multimediaContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Gallery {\n    images {\n      __typename\n    }\n  }\n  ...entityLink\n  ...helpersGetLabelContent\n  ...hooksContentItemProvidersContent_3SIuYu\n}\n\nfragment multimediaPodcastContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    images {\n      style(filter: {style: \"100x100\"}) {\n        url\n      }\n    }\n  }\n  ... on Podcast {\n    podcastSections {\n      images {\n        style(filter: {style: \"100x100\"}) {\n          url\n        }\n      }\n      name\n      id\n    }\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment multimediaQuery_4rBIay on Query {\n  multimedia: queue(filter: {name: $multimediaQueueName}) {\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            types {\n              value {\n                name\n                id\n              }\n            }\n          }\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...multimediaContentItemContent\n            ...multimediaPodcastContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment onePostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazinePrimaryContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment onePostMagSectionTopWidgetSponsorQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazinePrimaryContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment oneSectionTopWidgetQueue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...homeSecondaryContentItemContent\n      ...sectionTopLeadPrimaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo on Query {\n  openQuestionSeriesTopic: topic(filter: {entityId: \"518656\"}) {\n    name\n    urlAlias\n    contents(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, first: 6, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusWidgetDailyPulseQuery_3abQBm on Query {\n  dailyPulseQuery: articles(filter: {typeIds: [$dailyPulseTypeUuId]}, first: 1, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        urlAlias\n        ...entityLink\n        ...contentHeadlineContent\n        ...hooksArticleDateUtilsContent\n        ...hooksPlusArticleLinkHandlerArticle\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetHasAccessQuery_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment plusWidgetHighlight on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersGetArticleTypeArticle\n  ...hooksContentItemProvidersContent_2Mm1vQ\n  ...plusArticleTypeTitleContent\n}\n\nfragment plusWidgetHighlightsQuery_3iQMXB on Query {\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    items(first: 2) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...plusWidgetHighlight\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment plusWidgetNewsAgendaQuery_3kWRW2 on Query {\n  topics(first: 5, applicationId: $applicationId, filter: {types: $plusNewsAgendaTypes, newsAgendaDateRange: {startDate: $plusNewsAgendaStartDate, endDate: $plusNewsAgendaEndDate}, newsAgendaOptions: [\"key_event\"]}, orderBy: {field: NEWS_AGENDA_START_DATE, direction: ASC}) {\n    edges {\n      node {\n        ...itemAgendaItemTopic\n        ...hooksNewsAgendaTopic\n        newsAgenda {\n          newsAgendaOptions\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetQuery_1YyBVf on Query {\n  ...plusWidgetWithoutAccess_1YyBVf\n  ...plusWidgetHasAccessQuery_1YyBVf\n  ...hooksPlusWidgetConfigQuery\n}\n\nfragment plusWidgetWithoutAccess_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment popupArticle20ShareMenuContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n}\n\nfragment postMagazineDiscoveryItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...articleCommentArticle\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_14w7Xi\n}\n\nfragment postMagazineLeadContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_gwnn5\n}\n\nfragment postMagazineNewsletter on Query {\n  newsletter(filter: {entityId: \"322743\"}) {\n    description {\n      text\n    }\n    summary {\n      text\n    }\n    id\n  }\n}\n\nfragment postMagazinePrimaryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_9hDaW\n}\n\nfragment postMagazineSectionWidgetThreeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_1YIyJs\n}\n\nfragment postMagazineSectionWidgetTwoContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3hlRa7\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionDescriptionSection on Section {\n  description {\n    text\n    json\n  }\n}\n\nfragment sectionEditorPicksContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...contentCoverImageContent_aft1q\n  ...hooksContentItemProvidersContent_1WHnPc\n}\n\nfragment sectionEditorPicksQueue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...sectionEditorPicksContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment sectionNewsletterWidgetQuery_49mQWb on Query {\n  section(filter: {entityId: $entityId}) {\n    entityId\n    id\n  }\n}\n\nfragment sectionPostMagazineQuery_GVfS0 on Query {\n  ...headerPostMagazineQuery\n  ...postMagazineNewsletter\n  section(filter: {entityId: $entityId}) {\n    entityId\n    advertZone(version: 2)\n    id\n  }\n  leadStoryPostMagQueue: queue(filter: {name: $articlesQueueName}) {\n    items(first: 6) {\n      edges {\n        ...onePostMagSectionTopWidgetArticles\n        ...twoPostMagSectionTopWidgetArticles\n        ...threePostMagSectionTopWidgetArticles\n        node {\n          __typename\n          ...leadStoryPostMagazineContent\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  sponsorQueue: queue(filter: {name: $sponsorQueueName}) {\n    items(first: 6) {\n      edges {\n        ...onePostMagSectionTopWidgetSponsorQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment sectionSeoSection on Section {\n  name\n  description {\n    text\n  }\n  entityId\n  entityUuid\n  image(filter: {type: OG}) {\n    url\n  }\n  parentSection\n  urlAlias\n  ...hooksUseDeepLinkTagsBase\n  ...hooksUseDynamicMetaTags\n}\n\nfragment sectionSpotlightQuery_S3w6I on Query {\n  sectionSpotlightQueue: queue(filter: {name: $sectionSpotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...topStoriesBlockQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment sectionStyleContentQuery_jhigl on Query {\n  ...sectionStyleMainQuery_jhigl\n}\n\nfragment sectionStyleFashionCarouselQuery on Query {\n  fashionCarousel: queue(filter: {name: \"style_fashion_carousel\"}) {\n    items {\n      edges {\n        node {\n          __typename\n          ... on BaseWithApplicationAndUrlAlias {\n            __isBaseWithApplicationAndUrlAlias: __typename\n            entityId\n          }\n          ...magazinesStyleFashionCarouselContentItemContent\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment sectionStyleMainArticleListQueue_3z2gQm on Queue {\n  items(first: 4, exclude: {types: VIDEO}) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          ...magazinesStyleLeadContentItemContent\n          ...magazinesStyleCardContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment sectionStyleMainArticleListQueue_4yQIxA on Queue {\n  items(first: 3, exclude: {types: VIDEO}) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          ...magazinesStyleLeadContentItemContent\n          ...magazinesStyleCardContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment sectionStyleMainArticleListSection on Section {\n  ...sectionStyleSectionSection\n}\n\nfragment sectionStyleMainQuery_jhigl on Query {\n  topArticleQueue: queue(filter: {name: $articlesQueueName}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  luxurySection: section(filter: {entityId: \"322897\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  luxuryArticleQueue: queue(filter: {name: \"section_top_322897\"}) {\n    ...sectionStyleMainArticleListQueue_3z2gQm\n    id\n  }\n  fashionSection: section(filter: {entityId: \"516294\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  fashionArticleQueue: queue(filter: {name: \"section_top_516294\"}) {\n    ...sectionStyleMainArticleListQueue_3z2gQm\n    id\n  }\n  beautySection: section(filter: {entityId: \"516298\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  beautyArticleQueue: queue(filter: {name: \"section_top_516298\"}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  peopleSection: section(filter: {entityId: \"516301\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  peopleArticleQueue: queue(filter: {name: \"section_top_516301\"}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  lifestyleSection: section(filter: {entityId: \"516305\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  lifestyleArticleQueue: queue(filter: {name: \"section_top_516305\"}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  ...sectionStyleFashionCarouselQuery\n  ...sectionStyleSpotlightQuery\n  ...sectionStyleVideoWidgetQuery\n}\n\nfragment sectionStyleSectionSection on Section {\n  name\n  images(filter: {type: {values: [\"logo\"]}}) {\n    url\n  }\n  ...entityLink\n}\n\nfragment sectionStyleSpotlightQuery on Query {\n  spotlight: queue(filter: {entityId: \"4335\"}) {\n    items {\n      edges {\n        node {\n          __typename\n          ... on BaseWithApplicationAndUrlAlias {\n            __isBaseWithApplicationAndUrlAlias: __typename\n            entityId\n          }\n          ...magazinesStyleSpotlightContentItemContent\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment sectionStyleVideoWidgetQuery on Query {\n  styleVideoSectionPicksQueue: queue(filter: {name: \"video_section_picks_323289\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Video {\n            duration\n            entityId\n            headline\n            socialHeadline\n            image(filter: {type: MAIN_IMAGE}) {\n              style(filter: {style: \"wide_landscape\"}) {\n                url\n              }\n            }\n            ...helpersGetVideoYoutubeIdVideo\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment sectionTermLogoSection on Section {\n  name\n  sectionLogo: image(filter: {type: TERM_LOGO}) {\n    style(filter: {style: \"100x100\"}) {\n      url\n    }\n  }\n}\n\nfragment sectionTopLeadPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_34Njms\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2gnGW2\n}\n\nfragment shareArticle20Content on Content {\n  __isContent: __typename\n  ...popupArticle20ShareMenuContent\n}\n\nfragment shareHeaderFeaturesContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment thisWeekInAsiaDiscoveryWidgetQuery on Query {\n  twiaSection: section(filter: {entityId: \"323045\"}) {\n    ...latestDiscoveryWidgetSection\n    ...sectionTermLogoSection\n    urlAlias\n    name\n    id\n  }\n  twiaQueue: queue(filter: {name: \"section_top_323045\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment threePostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazineSectionWidgetThreeContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topStoriesBlockQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...topStoriesItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment trendingTopicTopic_4tMn4o on Query {\n  trendingTopicsQueue: queue(filter: {name: $trendingTopicsQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            ...entityLink\n            ...followButtonBase\n            name\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment twoPostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazineSectionWidgetTwoContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2154d66aaf3b59aac4610850cb462e38";

export default node;
